<template>
  <mdc-dialog class="bids-modal"
              v-model="isOpen"
              :title="'bids.view_bid' | trans"
              @cancel="cancel"
              @close="cancel">

    <div class="close-cross" @click="cancel">
      <mdc-icon icon="close"></mdc-icon>
    </div>


    <div class="form-group row">
      <div class="col-md-12">
        <div class="text-block">
          <p class="text-block__subtitle">
            {{'bids.protocol_goal' | trans}}
          </p>

          <p class="text-block__text">
            {{bid.description}}
          </p>
        </div>
      </div>
    </div>



    <div class="form-group row">
      <div class="col-md-12">
        <div class="text-block" v-if="bid.comments != null">
          <hr/>

          <p class="text-block__title">{{'bids.comments' | trans}}</p>

          <div v-if="bid.comments.count > 0">
            <div v-for="commentary in bid.comments.data">
              <p class="text-block__subtitle">
                {{commentary.user.name}}
              </p>

              <p class="text-block__text">
                {{commentary.text}}
              </p>
            </div>
          </div>

          <p class="text-block__text" v-else>
            {{'bids.no_data' | trans}}
          </p>
        </div>
      </div>
    </div>

    <footer class="mdc-dialog__footer mdc-dialog__footer--visible">
      <button type="button" class="mdc-button mdc-dialog__footer__button mdc-dialog__footer__button--cancel" @click="cancel"> {{'bids.buttons.cancel' | trans}}</button>
    </footer>
  </mdc-dialog>
</template>

<script>
  import lang from '../../../lang/translator';
  import isEmpty from 'lodash/isEmpty';
  import isObject from 'lodash/isObject';

  export default {
    name: 'BidsViewModal',
    props: {
      'visible': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'data': {
        type: Object,
        default() {
          return {};
        },
      },
    },
    data() {
      return {
        bid: [],
      };
    },
    methods: {
      close() {
        this.$emit('close');
      },
      cancel() {
        this.$emit('cancel');
      },
    },
    computed: {
      isEdit() {
        return !isEmpty(this.data);
      },
      isOpen: {
        get() {
          return this.visible;
        },
        set() {
        }
      },
    },
    watch: {
      visible() {
        if (this.isEdit) {
          if (this.data.item && this.data.item.comments && isObject(this.data)) {
            try {
              this.bid = this.data.item;
            } catch (e) {
              console.error('Unknown API error occurred.');
            }
          }
        }
      },
    },
  };
</script>


// WEBPACK FOOTER //
// src/modules/bids/components/ViewModal.vue